import { ICS2ArrivalNotificationMessage } from 'store/declarations/eu/ics2/arrival/ics2-arrival-notification-declaration';
import { ArrivalMessageTypes, toIcs2Notification } from './arrivalMessageUtils';
import IE3N07Details from './messages/IE3N07Details';
import IE3N08Details from './messages/IE3N08Details';
import IE3N99Details from './messages/IE3N99Details';
import IE3R04Details from './messages/IE3R04Details';
import RawData from 'views/declarations/common/declaration-errors-drawer/RawData';

type Props = {
    message: ICS2ArrivalNotificationMessage;
    onBack: () => void;
};

const ArrivalMessageDetails = ({ message, onBack }: Props) => {
    switch (message.messageType) {
        case ArrivalMessageTypes.REJECTION:
            return <IE3N99Details message={message} />;
        case ArrivalMessageTypes.HOUSE_STATE:
            return <IE3N07Details message={message} onBack={onBack} />;
        case ArrivalMessageTypes.CONTROL:
            return <IE3N08Details message={message} onBack={onBack} />;
        case ArrivalMessageTypes.REGISTRATION:
            return <IE3R04Details message={message} onBack={onBack} />;
        default:
            return <RawData notification={toIcs2Notification(message)} rawMessage={message.rawMessage ?? ''} />;
    }
};

export default ArrivalMessageDetails;
